'use client';

import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Button } from "../../atoms/Button/Button.js";
import { classNames } from "../../utils/styles/classNames.js";
import { defaultProps } from "./ButtonGroup.defaultProps.js";
import { fullHorizontalWrapper, orientation, dynamic, vertical, horizontalFullWidthOnMobile, horizontal, container } from "./ButtonGroup.css.js";
function ButtonGroupComponent({
  className,
  orientation: orientationProp,
  buttons,
  size: sizeProp,
  onDark = false,
  fullWidthOnMobile
}) {
  const orientation$1 = orientationProp || defaultProps.orientation;
  const size = sizeProp || defaultProps.size;
  const horizontalClassname = fullWidthOnMobile ? horizontalFullWidthOnMobile : horizontal;
  if (buttons.length === 0) return null;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(
        className,
        container,
        orientation$1 === "horizontal" && horizontalClassname,
        orientation$1 === "vertical" && vertical,
        orientation$1 === "dynamic" && dynamic,
        orientation[orientation$1]
      ),
      children: buttons.map((buttonProps) => {
        let { emphasis } = buttonProps;
        if (emphasis === "lowCompact" && buttons.length > 1) {
          emphasis = "low";
        }
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(
              fullWidthOnMobile && orientation$1 === "horizontal" && fullHorizontalWrapper
            ),
            children: /* @__PURE__ */ jsx(
              Button,
              {
                ...buttonProps,
                emphasis,
                fullWidth: fullWidthOnMobile && orientation$1 === "horizontal" || orientation$1 === "vertical" || orientation$1 === "dynamic",
                hiddenLabel: orientation$1 === "horizontal" && buttonProps.hiddenLabel,
                size,
                onDark,
                children: buttonProps.label
              }
            )
          },
          buttonProps.label
        );
      })
    }
  );
}
const ButtonGroup = /* @__PURE__ */ memo(ButtonGroupComponent);
export {
  ButtonGroup
};
